/**
 * #5 Partner enquiry — /partner-programme and the EPOS / e-commerce partner
 * income calculators. Shorter than the full application; lands in the
 * Partner layout. Calculator state (merchants, size, projected income)
 * arrives as `context`.
 */
import { company, email, firstName, lastName, phone, website } from "./common";

const opt = (label, crm) => ({ value: label, label, crm });

export const PARTNER_TYPES = [
  opt("Web developer / agency", "Agency"),
  opt("EPOS provider", "EPOS"),
  opt("Software / platform", "Developer"),
  opt("Consultant / accountant", "Consultant"),
  opt("Lead generator / network", "Lead Generator"),
  opt("Affiliate / influencer", "Affiliate"),
  opt("Other", null),
];

const partnerEnquiry = {
  id: "partner_enquiry",
  label: "Partner enquiry",
  crm: {
    layout: "Partner",
    leadSource: "Website Partner Enquiry",
    tags: (values, ctx) => (ctx.calculator ? [`Partner calculator: ${ctx.calculator}`] : []),
  },
  fields: [
    [firstName, lastName],
    [email, phone],
    { ...company, label: "Company" },
    { ...website, name: "partner_website" },
    { name: "partner_type", type: "select", label: "What best describes you?", options: PARTNER_TYPES, crm: "Partner_Type" },
    {
      name: "message", type: "textarea", label: "Tell us about your clients", crm: "Description", maxLength: 2000,
      placeholder: "Roughly how many merchants you work with, the platforms they use...",
    },
  ],
  submitLabel: "Talk to the partner team",
  consent: { variant: "condensed" },
  success: {
    title: "Thanks — we'll be in touch",
    body: "Our partner team will contact you shortly to talk through the programme.",
  },
  summary: (values, ctx) => {
    const parts = ["Partner enquiry", values.partner_type];
    if (ctx.calculator && ctx.merchants) parts.push(`${ctx.merchants} merchants (${ctx.calculator} calculator)`);
    return parts.filter(Boolean).join(" · ");
  },
};

export default partnerEnquiry;

/** Partner income calculator state → readable context for the Lead's Note. */
export function partnerCalculatorContext(calculator, state) {
  if (!state || !state.results) return { calculator };
  const r = state.results;
  const gbp = (n) => `£${Math.round(n).toLocaleString("en-GB")}`;
  return {
    calculator,
    merchants: state.merchantCount,
    merchant_size: state.size,
    referred_monthly_volume: gbp(r.totalVolume),
    projected_monthly_income: gbp(r.partnerMonthlyIncome),
    projected_annual_income: gbp(r.partnerAnnualIncome),
  };
}
